'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _css2 = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WithDrawList = _react2.default.createClass({
  displayName: 'WithDrawList',

  propTypes: {
    data: _react.PropTypes.object.isRequired
  },
  render: function render() {
    var _this = this;

    var columns = [{
      title: '流水号',
      key: 'id',
      dataIndex: 'payment_id'
    }, {
      title: '用户名',
      key: 'user',
      dataIndex: 'payee_account.owner.name'
    }, {
      title: '姓名',
      key: 'holder',
      dataIndex: 'payee_account.holder'
    }, {
      title: '银行卡号',
      key: 'bankNumber',
      dataIndex: 'payee_account.number'
    }, {
      title: '提现金额',
      key: 'fee',
      dataIndex: 'fee'
    }, {
      title: '状态',
      key: 'status_info',
      dataIndex: 'status_info'
    }, {
      title: '备注',
      key: 'memo',
      dataIndex: 'memo'
    }, {
      title: '申请时间',
      key: 'created_at',
      dataIndex: 'created_at'
    }, {
      title: '操作',
      key: 'change_status',
      dataIndex: 'status',
      render: function render(text, record) {
        if (text === 1) {
          return _react2.default.createElement(
            _button2.default,
            { onClick: function onClick(e) {
                return _this.props.handleStatusChange(record.payment_id);
              } },
            '\u63D0\u73B0\u5B8C\u6210'
          );
        }
      }
    }];
    var data = this.props.data;
    var items = data.items,
        error = data.error,
        pagination = data.pagination;

    var pager = Object.assign(_constants.PaginationConfig, {
      total: pagination.total,
      current: pagination.current_page,
      pageSize: pagination.per_page,
      onChange: function onChange(page, pageSize) {
        // 页码改变的回调，参数是改变后的页码及每页条数
        _this.props.onChange(page);
      }
    });
    var tableConfig = {
      columns: columns,
      locale: { emptyText: error && !error.ok ? '\u7F51\u7EDC\u9519\u8BEF\uFF1A' + error.statusText : '暂无数据' },
      dataSource: items,
      rowKey: function rowKey(record) {
        return record.payment_id;
      },
      pagination: pager
    };
    return _react2.default.createElement(_table2.default, tableConfig);
  }
});

exports.default = WithDrawList;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/withdraw_list.js
// module id = 1576
// module chunks = 0